import * as yup from "yup";
import * as ValidationRule from "../../utils/ValidationRule";

export default class QuotationRequest {

    constructor(jsonResponse) {
        if (jsonResponse) {
            this.id = jsonResponse["id"];
            this.countryId = jsonResponse["country-id"];
            this.payoutMethodId = jsonResponse["payout-method-id"];
            this.payoutPartnerId = jsonResponse["payout-partner-id"];
            this.currencyId = jsonResponse["currency-id"];
            this.quotationType = jsonResponse["quotation-type"];
            this.amount = jsonResponse["amount"];
        }
    }

    static create(countryId, payoutMethodId, payoutPartnerId, currencyId, quotationType, amount, registrationId) {
        let newQuotation = new QuotationRequest();
        newQuotation.countryId = countryId;
        newQuotation.payoutMethodId = payoutMethodId;
        newQuotation.payoutPartnerId = payoutPartnerId;
        newQuotation.currencyId = currencyId;
        newQuotation.quotationType = quotationType;
        newQuotation.amount = amount;
        newQuotation.registrationId = registrationId;
        return newQuotation;
    }

    static toJson = function (obj) {
        let jsonObj = {};
        jsonObj["country-id"] = obj.countryId;
        jsonObj["payout-method-id"] = obj.payoutMethodId;
        jsonObj["payout-partner-id"] = obj.payoutPartnerId;
        jsonObj["currency-id"] = obj.currencyId;
        jsonObj["quotation-type"] = obj.quotationType;
        jsonObj["amount"] = obj.amount;
        jsonObj["registration-id"] = obj.registrationId;
        return jsonObj;
    };
}

export function getAmountValidation(customText, required) {

        return yup.object().shape({
            amount: ValidationRule.getDecimalRule(customText, required)
        })
}